import React from "react";
import Header from "../Header/Header.tsx";
import Footer from "../Footer/Footer.tsx";
import { useHistory } from "react-router-dom";
import CommonBtn from "../CommonComponent/CommonBtn.tsx";
import { amenities4 } from "../../Assets.tsx";

const RoomSwimPage = () => {
  const history = useHistory();
  return (
    <>
      <Header />
      <div style={{ position: "relative", width: "100%", height: "auto",top:"10px" }}>
        <img
          style={{ width: "100%", height: "90vh" }}
          src={amenities4}
          alt="Couple Room"
        />
        <div
          style={{
            width: "80%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <a
            href="#Amenities"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none" }}
          >
            <button
              style={{
                display: "flex",
                alignSelf: "start",
                padding: "10px",
                backgroundColor: "black",
                color: "white",
                border: "none",
                cursor: "pointer",
                borderRadius: "30px",
                marginBottom: "5px",
              }}
            >
              Back
            </button>
          </a>
          <h1 style={{ fontSize: "50px", color: "white" }}>
            Room with Swimming pool
          </h1>
          <CommonBtn />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RoomSwimPage;
